import React from 'react'
import { Text, Flex, Box } from '@fundamentals'
import { EastOutlined } from '@mui/icons-material'
import { TimelineBlockBase } from './TimelineBlockBase'
import { AuditResultMetadata } from '@core/entities/audit/AuditResult/AuditResultMetadata'
import { localizedStrings } from '@core/strings'

type TimelineCompanyDiffBlockProps = {
  metadata: AuditResultMetadata
}

export const TimelineCompanyDiffBlock: React.FC<
  TimelineCompanyDiffBlockProps
> = ({ metadata }) => {
  const preCompanyData = metadata.preCompanyDataValues
  const postCompanyData = metadata.postCompanyDataValues

  if (!preCompanyData || !postCompanyData) {
    return null
  }

  const hasChanges =
    preCompanyData.name !== postCompanyData.name ||
    preCompanyData.code !== postCompanyData.code

  if (!hasChanges) {
    return (
      <TimelineBlockBase title={localizedStrings.companyName}>
        <Text variant='body2' color='text.secondary'>
          {localizedStrings.noChangesDetected}
        </Text>
      </TimelineBlockBase>
    )
  }

  return (
    <TimelineBlockBase title={localizedStrings.companyName}>
      <Flex alignItems='center'>
        <Box>
          <Text>{preCompanyData.name}</Text>
          {preCompanyData.code && (
            <Text color='text.secondary' fontSize={12}>
              {preCompanyData.code}
            </Text>
          )}
        </Box>

        <EastOutlined sx={{ color: 'text.secondary', mx: 2 }} />

        <Box>
          <Text>{postCompanyData.name}</Text>
          {postCompanyData.code && (
            <Text color='text.secondary' fontSize={12}>
              {postCompanyData.code}
            </Text>
          )}
        </Box>
      </Flex>
    </TimelineBlockBase>
  )
}
